/** Tranches d'âge communes BL-0027 / BL-0028 (jours inclus, ventilation exclusive). */
export const U2000_AGING_BUCKETS = ["0_30", "31_60", "61_90", "91_120", "121_180", "180_plus"] as const;

export type U2000AgingBucket = (typeof U2000_AGING_BUCKETS)[number];
